import parsePhoneNumber, { CountryCode } from 'libphonenumber-js'
import React from 'react'
import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'
import { useRestaurantRoutes } from 'src/shared/components/common/restaurant_routes/RestaurantRoutesContext'
import Image from 'src/shared/components/common/Image'
import { t } from 'src/translations/src'
import Link from 'src/shared/components/common/link'
import { getLocationPickerPath } from 'src/public/components/pages/location_selection_page/locationSelectionUtils'

export const OrderNotFoundSection = () => {
  const { orderPath } = useRestaurantRoutes()
  const { selectedLocation, ooRestaurant, restaurant } = useRestaurant()
  const locationPickerPath = getLocationPickerPath(
    ooRestaurant?.managementSetGuid || restaurant?.externalId,
    restaurant?.externalRef
  )

  const isMultiLocationWithPath =
    !!(restaurant.locations?.length && restaurant.locations.length > 1) &&
    !!locationPickerPath

  const backToMenuPath = isMultiLocationWithPath
    ? locationPickerPath
    : orderPath

  const i18nCountryCode = (ooRestaurant?.i18n?.country || 'US') as CountryCode
  const parsedPhoneNumber = selectedLocation.phoneNumber
    ? parsePhoneNumber(selectedLocation.phoneNumber, i18nCountryCode)
    : null
  return (
    <div
      className='orderConfirmationSection mediumPadding noOrderFound'
      data-testid='order-not-found-section'
    >
      <Image
        src={'icons/orderConfirmation/order-not-found.svg'}
        alt=''
        className='orderStatusIcon'
        data-testid='order-status-icon'
      />
      <div className='textContainer'>
        <h1>{t('order-confirmation.order-not-found.header')}</h1>
        <p>{t('order-confirmation.order-not-found.subtitle')}</p>
        <div className='orderNotFoundButtons'>
          {parsedPhoneNumber?.isValid() && (
            <Link
              className='orderConfirmationButton'
              type='button'
              data-testid='contact-restaurant-button'
              href={`tel:${parsedPhoneNumber.number}`}
            >
              {t('order-confirmation.order-not-found.contact-restaurant')}
            </Link>
          )}
          <Link
            className='orderConfirmationButton secondary'
            type='button'
            data-testid='back-to-menu-button'
            sameTab
            href={backToMenuPath}
          >
            {isMultiLocationWithPath
              ? t('nav-content.back-to-ordering')
              : t('order-confirmation.order-not-found.back-to-menu')}
          </Link>
        </div>
      </div>
    </div>
  )
}
